"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MediaQueries = _interopRequireDefault(require("../../../../../MediaQueries"));

var _StyledLayout = require("../../../../../StyledLayout");

var _templateObject;

// eslint-disable-next-line import/prefer-default-export
var FooterBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__FooterBox",
  componentId: "sc-88v3sn-0"
})(["background:", ";box-sizing:border-box;flex-direction:column;position:fixed;bottom:0;width:100%;z-index:2;padding:8px;", " a{&:hover{color:", ";font-weight:bold;}}"], function (props) {
  return props.theme.portfolioBackground1;
}, _MediaQueries["default"].minWidth.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 8px 48px;\n  "]))), function (props) {
  return props.theme[props.colour];
});
exports.FooterBox = FooterBox;